import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { RenaultCampaignContactImpactHistoric, RenaultCampaignContactImpactHistoricParams, RenaultLocalCampaignTelemarketingOrderDataDTO, RenaultLocalCampaignTelemarketingOrderDataOtherMediasDTO } from '../models/renault-local-campaign-telemarketing-order-data-dto';

@Injectable({
  providedIn: 'root'
})

export class LocalCampaignTelemarketingOrderDataService {

  private pathAPI = environment.urlAPI;
  private controller = "RenaultLocalCampaignTelemarketingOrderData/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<RenaultLocalCampaignTelemarketingOrderDataDTO> {
    return this.http.get<RenaultLocalCampaignTelemarketingOrderDataDTO>(this.pathAPI + this.controller + id);
  }

  public put(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public getDataTable(data: any, idOrder: string, idStatus: number): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idOrder + "/" + idStatus, data);
  }

  public getOtherMediasDatatable(data: any, id: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetOtherMediasDatatable/' + id, data);
  }

  public getOtherMedia(id: string): Observable<RenaultLocalCampaignTelemarketingOrderDataOtherMediasDTO> {
    return this.http.get<RenaultLocalCampaignTelemarketingOrderDataOtherMediasDTO>(this.pathAPI + this.controller + 'GetOtherMedia/' + id);
  }

  public UpdateTelemarketingOrderDataStatus(idOrder: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "UpdateTelemarketingOrderDataStatus/" + idOrder);
  }

  public GetCampaignContactImpactHistoric(data: RenaultCampaignContactImpactHistoricParams): Observable<RenaultCampaignContactImpactHistoric[]> {
    return this.http.post<RenaultCampaignContactImpactHistoric[]>(this.pathAPI + this.controller + 'GetCampaignContactImpactHistoric/', data);
  }

  public ShowOnlyWarningsButton(idOrder: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "ShowOnlyWarningsButton/" + idOrder);
  }



}
